import React from "react";
import Switch from "@mui/material/Switch";
import { useTranslation } from "react-i18next";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";

// Bir xil nomli yozuvlardan faqat oxirgisini (eng katta id) qoldiradi
export const uniqueByName = (list) => {
  const byName = new Map();
  (list || []).forEach((item) => {
    const key = String(item?.name ?? "").trim().toLowerCase();
    const prev = byName.get(key);
    if (prev && Number(prev.id) > Number(item.id)) return;
    byName.delete(key);
    byName.set(key, item);
  });
  return [...byName.values()];
};

export const SectionHead = ({ index, title, children }) => (
  <div className="af-card__head">
    <div className="af-card__title">
      <span className="af-card__num">{index}</span>
      <h5>{title}</h5>
    </div>
    {children}
  </div>
);

export const ChooseFrom = ({
  onChange,
  disabled,
  label,
  tooltip,
  defaultChecked = false,
}) => {
  const { t } = useTranslation();
  return (
    <div className={disabled ? "af-toggle af-toggle--disabled" : "af-toggle"}>
      <Switch
        size="small"
        disabled={disabled}
        defaultChecked={defaultChecked}
        onChange={onChange}
      />
      <span>{label ?? t("choose_from")}</span>
      <Tooltip
        placement="top"
        title={tooltip ?? t("last_info")}
        color={"#109cf1"}
      >
        <InfoCircleOutlined className="af-toggle__info" />
      </Tooltip>
    </div>
  );
};

// HTML matnda haqiqiy kontent bormi (bo'sh <p></p> va &nbsp; hisobga olinmaydi)
export const isFilled = (html) =>
  !!String(html ?? "")
    .replace(/<[^>]*>|&nbsp;/g, "")
    .trim();

export const fileKind = (name) => {
  const ext = String(name ?? "").split(".").pop().toLowerCase();
  if (ext === "pdf") return "pdf";
  if (["doc", "docx"].includes(ext)) return "word";
  if (["ppt", "pptx"].includes(ext)) return "ppt";
  if (["jpg", "jpeg", "png"].includes(ext)) return "img";
  return "other";
};
